import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1)

import {onMounted} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

onMounted(()=>{
  initMap()
})

function initMap(){
  var map = new window.BMapGL.Map("container");
  const point = new window.BMapGL.Point(120.729386,31.270316); // 坐标点的经度和纬度
  map.centerAndZoom(point, 19); // 设置中心点和缩放级别
  const markerPoint = new window.BMapGL.Point(120.729381,31.270285); // 坐标点的经度和纬度
  const marker = new window.BMapGL.Marker(markerPoint);
  map.addOverlay(marker); // 添加标注到地图上
  const infoWindow = new window.BMapGL.InfoWindow("苏州RUUD全空气体验厅欢迎您");
  // const icon = new window.BMapGL.Icon("path-to-icon-image.png", new window.BMapGL.Size(30, 30));
  // const customMarker = new window.BMapGL.Marker(markerPoint, { icon: icon });
  (marker as any).addEventListener("click", function () {
    map.openInfoWindow(infoWindow, markerPoint); // 在标注上打开信息窗口
  });

}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" 22 "),
    _hoisted_1
  ], 64))
}
}

})